import { Skeleton, SkeletonList } from '@saas/ui';

/** 認証の復元・初回の遅延ロード中（画面全体を覆うスピナーは使わない） */
export function AppSkeleton() {
  return (
    <div className="mx-auto w-full max-w-5xl px-5 py-6" aria-busy="true" aria-label="読み込み中">
      <Skeleton width={220} height={28} className="mb-6" />
      <SkeletonList rows={4} />
    </div>
  );
}
